import React from 'react';
import II18 from '../translate/II18';
import { Icon, Button } from 'framework7-react';
import ThankyouContent from '../common/ThankyouContent';
import PropTypes from 'prop-types';

export default function DesktopThankyouPopUp(props) {
  const { onClosePopUp, companyName } = props;

  return (
    <div className="desktop-popup">
      <div className="desktop-popup-header no-border">
        <label></label>
        <Button onClick={onClosePopUp}>
          <Icon material={'close'} />
        </Button>
      </div>

      <div
        className="desktop-popup-body"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <ThankyouContent companyName={companyName} />
      </div>

      <div className="desktop-popup-footer">
        <div
          style={{
            display: 'flex',
            placeContent: 'flex-end'
          }}
        >
          <Button onClick={onClosePopUp}>
            <II18>title_close</II18>
          </Button>
        </div>
      </div>
    </div>
  );
}

DesktopThankyouPopUp.propTypes = {
  onClosePopUp: PropTypes.func,
  companyName: PropTypes.string
};
